/*!

=========================================================
* Black Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, BrowserRouter} from "react-router-dom";

import AuthLayout from "layouts/Auth/Auth.jsx";
import MainLayout from "layouts/App/Main.jsx";
import Auth from "components/Auth/Login.jsx";
import Request from "common/Request";
import AlertModal from 'views/ViewParts/AlertModal'

import "assets/css/nucleo-icons.css";
import "assets/css/black-dashboard-pro-react.css";
import "assets/demo/demo.css";
import "react-notification-alert/dist/animate.css";
import "assets/css/style.css";
import "assets/css/table-detail.css";
import { googleMapKey } from "variables/apikeys";
if (process.env.NODE_ENV !== 'development') {
  console.log = () => {}
}
const _error = console.error;
console.error = (err) => {
  // console.error(err)
  // _error(err)
  const location = window && window.location
  const path = (location && location.pathname)|| "unknown"
  // Request.post(`/api/logging`, { path, err }, (res)=>{}, (error)=>{},()=>{},true,false,false)
}

const hist = createBrowserHistory();
let alertModal = React.createRef();
const App = () => {
  React.useEffect(() => {
    const head = document.getElementsByTagName('head')[0]
    const zenrinScriptUrl = document.createElement('script')
    zenrinScriptUrl.type = 'text/javascript'
    let domain = 'test-app.zip-site.com'
    let key = 'ZAKpDFVvziHg4MZpxol7'
    switch(process.env.REACT_APP_MODE) {
      case 'development':
        zenrinScriptUrl.src = 'https://' + domain + '/auth/jsapi/loader.htm?key=' + key + '&type=special'
        break;
      case 'staging':
        zenrinScriptUrl.src = 'https://' + domain + '/auth/jsapi/loader.htm?key=' + key + '&type=special'
        break;
      case 'production':
        domain = 'app.zip-site.com';
        zenrinScriptUrl.src = 'https://' + domain + '/auth/jsapi/loader.htm?key=' + key + '&type=special'
        break;
    }
    // console.log(head)
    // scriptUrl.setAttribute("data-client-key", key)
    head.appendChild(zenrinScriptUrl)

    // const googleapisScriptUrl = document.createElement('script');
    // googleapisScriptUrl.type = 'text/javascript';
    // googleapisScriptUrl.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&libraries=drawing&v=weekly&channel=2`
    // head.appendChild(googleapisScriptUrl)
  },[])

  return (
    <>
      <Request alertModal={alertModal}/>
      <BrowserRouter>
        <Switch>
          <Route exact path="/login" render={props => <AuthLayout {...props} />} />
          <Auth>
            <Route render={props => <MainLayout {...props} alertModal={alertModal}/>} />
          </Auth>
        </Switch>
      </BrowserRouter>
      <AlertModal ref={alertModal}/>
    </>
  )
}
ReactDOM.render(<App />,
  document.getElementById("root")
);
